module.exports = __webpack_public_path__ + "static/media/20210212_210327_824_IMG_2120.9d8f80be.jpg";